import { TipoCompra } from './../model/tipoCompra';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { GenericResponse, SearchPedidoRequestDto, SearchPedidoResponse, PedidoDto, PedidoPresupuesto, SavePedidoPresupuesto, PedidoPermisosDto, SearchPedidoPresupuestoRequestDto, SearchPedidoPresupuestoResponse, PedidoHistorialDto, PedidoItemDto, AprobarPedidoDto, PedidoPresupuestoDetalle, PedidoMaterial, MaterialDto, SavePedidoPresupuestoSeleccion, PresupuestoDetallesByPedidoDto, SavePedidoHistorialDto, PedidoAdjunto, UploadPedidoAttachResponseDto, PedidoEntregasResponseDto, PedidoRemito, PedidoRemitoDetalle, RemitoDetallesByPedidoDto, SaveRecepcionPedido, SearchPedidoItemRequestDto, SearchPedidoItemResponse, SearchPedidoItemsPendientesEntregaRequestDto, SearchPedidoItemsPendientesEntregaResponse, SearchReporteEntregaRequestDto, GenericPieDashboardResponse, PedidoComunidadRolDto, Rol, SavePedidoPlanificacionDto, DarBajaPedidosResponseDto, BajaMasivaPedidosDto } from "../model/index";

@Injectable({
    providedIn: 'root'
})

export class PedidoService extends CrudService<PedidoDto, number, PedidoDto, SearchPedidoRequestDto> {
    constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'pedido', sharedFunctions);

  }

  getPedidoComunidadRoles(): Observable<GenericResponse<PedidoComunidadRolDto[]>> {
    return this._http.get<GenericResponse<PedidoComunidadRolDto[]>>(this._serviceUrl + '/comunidad-roles', this.httpOptions);
  }

  searchPedidos(p: SearchPedidoRequestDto): Observable<SearchPedidoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchPedidoResponse>(this._serviceUrl + '/search'+parameters, this.httpOptions);
  }

  getAttachments(id: number): Observable<GenericResponse<PedidoAdjunto[]>> {
    return this._http.get<GenericResponse<PedidoAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getPedidoHistorial(id: number): Observable<GenericResponse<PedidoHistorialDto[]>> {
    return this._http.get<GenericResponse<PedidoHistorialDto[]>>(this._serviceUrl + '/' + id + '/historial', this.httpOptions);
  }

  getPedidoAprobaciones(id: number): Observable<GenericResponse<PedidoHistorialDto[]>> {
    return this._http.get<GenericResponse<PedidoHistorialDto[]>>(this._serviceUrl + '/' + id + '/aprobaciones', this.httpOptions);
  }

  getPedidoItemById(id: number): Observable<GenericResponse<PedidoItemDto>> {
    return this._http.get<GenericResponse<PedidoItemDto>>(this._serviceUrl + '/item/' + id, this.httpOptions);
  }

  getPedidoItems(id: number): Observable<GenericResponse<PedidoItemDto[]>> {
    return this._http.get<GenericResponse<PedidoItemDto[]>>(this._serviceUrl + '/' + id + '/items', this.httpOptions);
  }

  getPedidoEntregas(id: number): Observable<GenericResponse<PedidoEntregasResponseDto>> {
    return this._http.get<GenericResponse<PedidoEntregasResponseDto>>(this._serviceUrl + '/entregas/' + id, this.httpOptions);
  }

  getPresupuesto(pedidoId: number, id: number): Observable<GenericResponse<PedidoPresupuesto>> {
    return this._http.get<GenericResponse<PedidoPresupuesto>>(this._serviceUrl + '/'+pedidoId+'/presupuesto/' + id, this.httpOptions);
  }

  getMaterial(pedidoId: number, id: number): Observable<GenericResponse<MaterialDto>> {
    return this._http.get<GenericResponse<MaterialDto>>(this._serviceUrl + '/'+pedidoId+'/material/' + id, this.httpOptions);
  }

  getPresupuestoDetalles(pedidoId: number, id: number): Observable<GenericResponse<PedidoPresupuestoDetalle[]>> {
    return this._http.get<GenericResponse<PedidoPresupuestoDetalle[]>>(this._serviceUrl + '/'+pedidoId+'/presupuesto/' + id + '/detalles', this.httpOptions);
  }

  getPresupuestoDetallesByPedidoId(pedidoId: number): Observable<GenericResponse<PresupuestoDetallesByPedidoDto>> {
    return this._http.get<GenericResponse<PresupuestoDetallesByPedidoDto>>(this._serviceUrl + '/'+pedidoId+'/presupuesto-detalles', this.httpOptions);
  }

  searchPresupuesto(p: SearchPedidoPresupuestoRequestDto): Observable<SearchPedidoPresupuestoResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchPedidoPresupuestoResponse>(this._serviceUrl + '/search-presupuestos'+parameters, this.httpOptions);
  }

  searchPedidoItems(p: SearchPedidoItemRequestDto): Observable<SearchPedidoItemResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchPedidoItemResponse>(this._serviceUrl + '/search-items'+parameters, this.httpOptions);
  }

  getSearchItemsUrl() {
    return this._serviceUrl + '/search-items';
  }

  searchPedidoPedidoEntregaPlanificada() {
    return this._serviceUrl + '/reporte-entregas-planificadas';
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadPedidoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadPedidoAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  aprobar(r: AprobarPedidoDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/aprobar', r, this.httpOptions);
  }

  rechazar(r: AprobarPedidoDto): Observable<GenericResponse<boolean>> {
    return this._http.post<GenericResponse<boolean>>(this._serviceUrl + '/rechazar', r, this.httpOptions);
  }

  deletePedido(pedidoId: number): Observable<GenericResponse<any>>{
    return this._http.delete<GenericResponse<any>>(this._serviceUrl + '/'+ pedidoId, this.httpOptions);
  }

  bajaMasivaPedidos(r: BajaMasivaPedidosDto): Observable<GenericResponse<DarBajaPedidosResponseDto>> {
    return this._http.post<GenericResponse<DarBajaPedidosResponseDto>>(this._serviceUrl + '/delete-pedidos', r, this.httpOptions);
  }

  savePedidoCabecera(r: PedidoDto): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/save-cabecera',r, this.httpOptions);
  }

  savePedidoItems(r: PedidoDto): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/save-items',r, this.httpOptions);
  }

  savePedidoItem(r: PedidoItemDto): Observable<GenericResponse<PedidoItemDto>>{
    return this._http.post<GenericResponse<PedidoItemDto>>(this._serviceUrl + '/save-item',r, this.httpOptions);
  }

  deletePedidoItem(id: number): Observable<GenericResponse<boolean>>{
    return this._http.delete<GenericResponse<boolean>>(this._serviceUrl + '/delete-item/'+id, this.httpOptions);
  }

  savePedidoAdjuntos(r: PedidoDto): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/save-adjuntos',r, this.httpOptions);
  }

  savePedidoPlanificacion(r: SavePedidoPlanificacionDto): Observable<GenericResponse<SavePedidoPlanificacionDto>>{
    return this._http.post<GenericResponse<SavePedidoPlanificacionDto>>(this._serviceUrl + '/save-planificacion',r, this.httpOptions);
  }

  getPermisos(pedidoId: number): Observable<GenericResponse<PedidoPermisosDto>> { 
    return this._http.get<GenericResponse<PedidoPermisosDto>>(this._serviceUrl + '/permisos/'+pedidoId, this.httpOptions);
  }

  getAllTipoCompra(): Observable<GenericResponse<TipoCompra[]>> {
    return this._http.get<GenericResponse<TipoCompra[]>>(this._serviceUrl + '/tipo-compra/all', this.httpOptions);
  }

  saveHistorial(r: SavePedidoHistorialDto): Observable<GenericResponse<PedidoHistorialDto>>{
    return this._http.post<GenericResponse<PedidoHistorialDto>>(this._serviceUrl + '/' + r.PedidoId + '/historial/save',r, this.httpOptions);
  }

  savePresupuesto(r:SavePedidoPresupuesto): Observable<GenericResponse<PedidoPresupuesto>>{
    return this._http.post<GenericResponse<PedidoPresupuesto>>(this._serviceUrl + '/save-presupuesto',r, this.httpOptions);
  }
  
  savePresupuestoComparativa(r:SavePedidoPresupuesto[]): Observable<GenericResponse<number[]>>{
    return this._http.post<GenericResponse<number[]>>(this._serviceUrl + '/save-presupuesto-comparativa',r, this.httpOptions);
  }

  savePresupuestoPrecargado(r:SavePedidoPresupuesto): Observable<GenericResponse<PedidoPresupuesto>>{
    return this._http.post<GenericResponse<PedidoPresupuesto>>(this._serviceUrl + '/save-presupuesto-precargado',r, this.httpOptions);
  }

  savePresupuestoSeleccion(r: SavePedidoPresupuestoSeleccion): Observable<GenericResponse<PedidoPresupuesto>>{
    return this._http.post<GenericResponse<PedidoPresupuesto>>(this._serviceUrl + '/save-presupuesto-seleccion',r, this.httpOptions);
  }

  deletePresupuesto(pedidoId: number, presupuestoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.delete<GenericResponse<PedidoDto>>(this._serviceUrl + '/'+pedidoId+'/presupuesto/'+presupuestoId, this.httpOptions);
  }

  getRemito(pedidoId: number, id: number): Observable<GenericResponse<PedidoRemito>> {
    return this._http.get<GenericResponse<PedidoRemito>>(this._serviceUrl + '/'+pedidoId+'/remito/' + id, this.httpOptions);
  }

  getRemitoDetalle(pedidoId: number, id: number): Observable<GenericResponse<PedidoRemitoDetalle[]>> {
    return this._http.get<GenericResponse<PedidoRemitoDetalle[]>>(this._serviceUrl + '/'+pedidoId+'/remito/'+id+'/detalles', this.httpOptions);
  }

  getRemitoDetallesByPedidoId(pedidoId: number): Observable<GenericResponse<RemitoDetallesByPedidoDto>> {
    return this._http.get<GenericResponse<RemitoDetallesByPedidoDto>>(this._serviceUrl + '/'+pedidoId+'/remito-detalles', this.httpOptions);
  }

  uploadRemitoAttach(remitoId: number, p: any): Observable<GenericResponse<UploadPedidoAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadPedidoAttachResponseDto>>(this._serviceUrl + '/' + remitoId + '/attach', formData, this.httpFormDataOptions);
  }

  searchItemsPendientesEntrega(p: SearchPedidoItemsPendientesEntregaRequestDto): Observable<SearchPedidoItemsPendientesEntregaResponse> {
    var parameters = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<SearchPedidoItemsPendientesEntregaResponse>(this._serviceUrl + '/search-items-pendientes-entrega'+parameters, this.httpOptions);
  }

  saveRemito(r: PedidoRemito): Observable<GenericResponse<PedidoRemito>>{
    return this._http.post<GenericResponse<PedidoRemito>>(this._serviceUrl + '/save-remito',r, this.httpOptions);
  }

  deleteRemito(pedidoId: number, presupuestoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.delete<GenericResponse<PedidoDto>>(this._serviceUrl + '/'+pedidoId+'/presupuesto/'+presupuestoId, this.httpOptions);
  }

  postEnviarPresupuestarPedido(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-presupuestar/'+pedidoId, this.httpOptions);
  }
  
  postEnviarRevisionPedido(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-revision/'+pedidoId, this.httpOptions);
  }

  postEnviarPendienteEntrega(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-pendiente-entrega/'+pedidoId, this.httpOptions);
  }

  postEnviarPendienteCoordinacion(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-pendiente-coordinacion/'+pedidoId, this.httpOptions);
  }

  postEnviarEntregado(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-entregado/'+pedidoId, this.httpOptions);
  }

  postEnviarFinalizado(pedidoId: number): Observable<GenericResponse<PedidoDto>>{
    return this._http.post<GenericResponse<PedidoDto>>(this._serviceUrl + '/enviar-finalizado/'+pedidoId, this.httpOptions);
  }

  exportReporteEntregas(value: SearchReporteEntregaRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-reporte-entregas-planificadas' + queryString, this.httpCsvOptions);
  }
  
  exportItemPedido(value: SearchPedidoItemRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-search-items' + queryString, this.httpCsvOptions);
  }

  exportSearchWithItems(value: SearchPedidoRequestDto): Observable<any> {
    var queryString = this.sharedFunctions.convertToQueryString(value);
    return this._http.get<any>(this._serviceUrl + '/export-search-with-items' + queryString, this.httpCsvOptions);
  }

  obtenerDashboardPedidosPorEstado(): Observable<GenericResponse<GenericPieDashboardResponse>> {
    return this._http.get<GenericResponse<GenericPieDashboardResponse>>(this._serviceUrl +'/dashboard-pedidos-por-estado', this.httpOptions);
  }

  getAprobadores(): Observable<GenericResponse<Rol[]>> {
    return this._http.get<GenericResponse<Rol[]>>(this._serviceUrl + '/aprobadores' , this.httpOptions);
  }
}